import firebase from 'firebase';
// import Notification from '../components/login/Notification'
// import { push } from 'react-router-redux';
// import PropTypes from 'prop-types';
// import { getNotification } from 'ra-core';
// import { translate, userLogin } from 'ra-core';

//import { getMaxListeners } from 'cluster';

export class AuthService {
  isAdmin = firebaseUserId => {
    return firebase
      .database()
      .ref(`admins/${firebaseUserId}`)
      .once('value')
      .then(snapshot => console.warn('SUCCESS ! You are an admin !'))
      .catch(error => {
        console.warn(
          `User id ${firebaseUserId} have no access sorry `,
          error.message
        );
        throw new Error('signin.error_not_admin');
      });
  };

  getRoleNumber = role => {
    return firebase
      .database()
      .ref(`roles/${role}`)
      .once('value')
      .then(snapshot => {
        const roleNumber = snapshot.val();
        return roleNumber;
      })
      .catch(error => {
        console.warn(`Refusé`, error.message);
        throw new Error('signin.error_not_admin');
      });
  };

  authRole = userId => {
    return firebase
      .database()
      .ref(`admins/${userId}`)
      .once('value')
      .then(snapshot => {
        let userRole = snapshot.val().role;
        return this.getRoleNumber(userRole);
      })
      .catch(error => {
        console.warn(`User id ${userId} have no access sorry `, error.message);
        throw new Error('signin.error_not_admin');
      });
  };

  authResetPasswordEmail = (email, showNotification) => {
    //   ApproveButton.propTypes = {
    //     push: PropTypes.func,
    //     record: PropTypes.object,
    //     showNotification: PropTypes.func,
    // };
    // console.warn(this);
    // console.warn(this.firebaseUserId)
    // console.warn(this.admins, params)
    var auth = firebase.auth();
    firebase.auth().languageCode = 'en';

    if (email) {
      auth
        .sendPasswordResetEmail(email)
        .then(() => {
          showNotification('signin.email_sent_confirmation', 'info', {
            messageArgs: { email }
          });
          // Email sent.
        })
        .catch(error => {
          // An error happened.
          showNotification('signin.email_error', 'warning', {
            messageArgs: { email }
          });
        });
    } else {
      showNotification('signin.email_needed', 'warning');
    }
  };
}



// WEBPACK FOOTER //
// ./src/services/AuthService.js